"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var FinanceQuotePrices_1 = require("../../../../../prices/finance/FinanceQuotePrices");
var multiCurrencyFinanceRatesBlockStyles_1 = require("./multiCurrencyFinanceRatesBlockStyles");
var LabelAfter_1 = require("../../../StaticContent/LabelAfter");
var Translation_1 = require("../../../../../../../common/components/presentation/Translation/Translation");
var MultiCurrencyFinanceRatesBlock = function (_a) {
    var totalPayable = _a.totalPayable, financeDetails = _a.financeDetails, isMultiCurrency = _a.isMultiCurrency, disclaimerText = _a.disclaimerText;
    var _b, _c;
    var style = multiCurrencyFinanceRatesBlockStyles_1.default();
    return (<>
      <core_1.Box>
        <FinanceQuotePrices_1.default primaryPrice={(_b = financeDetails) === null || _b === void 0 ? void 0 : _b.primary} secondaryPrice={(_c = financeDetails) === null || _c === void 0 ? void 0 : _c.secondary} isMultiCurrency={isMultiCurrency} variant="h4" className={style.financeQuotePrice} dataTest="finance_summary:container:primary_quote" labelAfter={<LabelAfter_1.default className={style.labelAfter} financeDetails={financeDetails}/>}/>
        <core_1.Typography data-test="finance_summary:text:labelAfter" variant="caption" component="div" className={style.repaymentLabel}>
          <Translation_1.default id={'financeSummary.label.estimateRepayment'} values={{ total: totalPayable }}/>
        </core_1.Typography>
      </core_1.Box>
      <core_1.Typography variant="subtitle1" data-test="finance_summary:text:disclaimer">
        {disclaimerText}
      </core_1.Typography>
    </>);
};
exports.default = MultiCurrencyFinanceRatesBlock;
